<template>
    <footer class="sajilo-footer sajilo-section">
      <div class="container">
        <section class="sajilo-footer__top">
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="3">
              <!-- <figure class="sajilo-footer__logo">
                <router-link to="/">
                  <img src="@/assets/images/sajilo-class.png" alt="Sajilo Class">
                </router-link>
              </figure> -->
              <article class="sajilo-footer__content">
                <h4 class="sajilo-footer__title">About Us</h4>
                <p class="text-justify">Sajilo class is an online learning platform that is beneficial to the students and especially to those who have trouble learning and understanding. The videos are designed in such a way that it allows students to get immersed and grasp the desired content.</p>
                <button type="button" @click="redirectToAbout()" class="button button_blue">View More</button>
              </article>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <article class="sajilo-footer__content pl-5">
                <h4 class="sajilo-footer__title">Contact Us</h4>
                <div class="sajilo-footer__info" v-if="location">
                  <v-icon>
                    {{ location.icon }}
                  </v-icon>
                  <span>{{ location.address }}</span>
                </div>
                <div class="sajilo-footer__info" v-if="phone">
                  <v-icon>
                    {{ phone.icon }}
                  </v-icon>
                  <span>
                    <!-- <a :href="`tel:${phone.mobile}`" v-if="phone.mobile">{{ phone.mobile }}</a>,  -->
                    <a :href="`tel:${phone.telephone}`" v-if="phone.telephone">{{ phone.telephone }}</a>
                  </span>
                </div>
                <div class="sajilo-footer__info" v-if="email">
                  <v-icon>
                    {{ email.icon }}
                  </v-icon>
                  <span><a :href="`mailto:${email.address}`">{{ email.address }}</a></span>
                </div>
              </article>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="3">
              <article class="sajilo-footer__content">
                <h4 class="sajilo-footer__title">Keep In Touch</h4>
                <ul class="sajilo-footer__social-list sajilo__social-list">
                  <li v-for="(item, i) in socialList" :key="i">
                    <SocialLink
                      :social="item"
                    ></SocialLink>
                  </li>
                </ul>
                <br>
                <h4 class="sajilo-footer__title">Useful Links</h4>
                <ul style="list-style: none; padding-left: 0;">
                  <li><span @click="terms()" style="cursor: pointer;">Terms Of Use</span></li>
                  <!-- <li><router-link to="/privacy-policy">Privacy Policy</router-link></li> -->
                </ul>
              </article>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <article class="sajilo-footer__content">
                <h4 class="sajilo-footer__title">Payment Partner</h4>
                <div class="sajilo-footer__payment-wrapper">
                  <figure>
                    <img src="@/assets/images/fone-pay.png" alt="fone-pay">
                  </figure>
                </div>
              </article>
            </v-col>
          </v-row>
        </section>
        <section class="sajilo-footer__bottom text-center">
          <div class="sajilo-footer__text">All rights reserved to <router-link to="/">Sajilo Class</router-link>. 2020</div>
        </section>
      </div>
    </footer>
</template>

<script>
import SocialLink from '@/components/Social/SocialLink.vue'

export default {
  data() {
    return {
      socialList: [
        { url: 'https://www.facebook.com/sajiloclas', icon: 'mdi-facebook' },
        { url: 'https://www.instagram.com/sajilo.class', icon: 'mdi-instagram' },
        // { url: '#', icon: 'mdi-twitter' },
        { url: 'https://www.youtube.com/channel/UCJBkIOHIlilhTTZ-iWtYOjw', icon: 'mdi-youtube' },
      ],
      location: {
        icon: 'mdi-map-marker',
        address: 'New Baneshwor, Kathmandu, Nepal',
      },
      phone: {
        icon: 'mdi-phone',
        // mobile: '9801058861',
        telephone: '01-5907400',
      },
      email: {
        icon: 'mdi-email',
        address: 'sajiloclass@gmail.com',
      },
    }
  },
  components: {
    SocialLink
  },
  methods: {
    redirectToAbout() {
      this.$router.push('/about');
      window.location.reload();
      window.scrollTo(0,0);
    },
    terms() {
      this.$router.push('/terms-of-use');
      window.scrollTo(0,0);
    }
  }
}
</script>

<style lang="scss" scoped>
  .sajilo-footer__info {
    display: flex;
    align-items: flex-start;
  }
  .sajilo-footer__info > .v-icon + * {
    flex: 1;
  }

</style>
